import { Modal as AntdModal, Button, Flex, ModalProps } from 'antd'
import { createStyles } from 'antd-style'

import { useLocales } from 'src/locales'

import { Text } from '../Typography'

const useStyle = createStyles(({ token }) => ({
  modal: {
    '& .ant-modal-content': {
      paddingInline: token.paddingLG,
      paddingBlock: token.paddingLG * 2
    },
    '.ant-modal-body': {
      padding: 0
    }
  },
  buttons: {
    width: 100
  }
}))

type Props = {
  icon?: React.ReactNode
  subTitle?: React.ReactNode
} & ModalProps

export const ConfirmModal = ({
  icon,
  title,
  subTitle,
  onCancel,
  onOk,
  loading,
  children,
  ...props
}: Props) => {
  const { styles } = useStyle()
  const { t } = useLocales()

  return (
    <AntdModal
      {...props}
      footer={null}
      centered
      onCancel={onCancel}
      className={styles.modal}
    >
      <Flex vertical gap={40}>
        <Flex align="center" gap={24} vertical>
          {icon && icon}

          <Flex className="text-center" vertical gap={8}>
            <Text className="lh-1" size="xxl" weight={700}>
              {title}
            </Text>
            {subTitle}
          </Flex>
        </Flex>

        {children}
        <Flex gap={8} align="center" justify="center">
          <Button
            loading={loading}
            size="large"
            onClick={onOk}
            type="primary"
            className={styles.buttons}
            {...props.okButtonProps}
          >
            {t('common.yes')}
          </Button>

          <Button
            size="large"
            onClick={onCancel}
            className={styles.buttons}
            {...props.cancelButtonProps}
          >
            {t('common.no')}
          </Button>
        </Flex>
      </Flex>
    </AntdModal>
  )
}
